import React, { FC, ReactNode } from 'react';
import './EditButton.css';
import { FaEdit } from '@/Shared/Lib/UI/Icons';
import { ActionButton } from '..';

interface EditButtonProps {
	onClick: () => void;
	label?: string;
	icon? : ReactNode;
	showLabel? : boolean;
	tooltip? : string;
	disabled? : boolean
}

const EditButton: FC<EditButtonProps> = ({ 
	onClick, 
	label = "Editer", 
	tooltip = "Bouton d'édition", 
	icon = <FaEdit />, 
	disabled,
	showLabel=false 
}) => (
	<ActionButton
	    classNames = "EditButton"
		icon={icon}
		label={label}
		onClick={onClick}
		showLabel={showLabel}
		tooltip={tooltip}
		disabled={disabled}
		
	/>
);

export default EditButton;


